import React, { FC, useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import Select from 'react-select';
import ErrorMessage from '@components/profile/profileOverlay/common/ErrorMessage';
import Input from '@components/common/input';
import { ReactSelectStyles } from '@components/profile/profileOverlay/overlays/ReactSelectStyles';
import styles from '../../militaryPreference.module.scss';
import { veteranStatusOptions } from '@domain/constant/profile/PreferentialType';

import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const VeteranForm: FC = () => {
  const { control, getValues, clearErrors } = useFormContext();
  const isVeteranStatusNone = getValues('veteran.status')?.value === 'NONE' || !getValues('veteran.status')?.value;

  const statusName = 'veteran.status';
  const {
    field: statusField,
    fieldState: statusMeta,
    formState: { errors: statusErrors },
  } = useController({
    name: statusName,
    control,
  });

  const reasonName = 'veteran.reason';
  const {
    field: reasonField,
    fieldState: reasonMeta,
    formState: { errors: reasonErrors },
  } = useController({
    name: reasonName,
    control,
  });

  useEffect(() => {
    if (isVeteranStatusNone) {
      reasonField.onChange(null);
      clearErrors('veteran.reason');
    }
  }, [isVeteranStatusNone]);

  return (
    <div className={cx('infoArea', 'veteran')}>
      <em className={cx('infoTitle')}>보훈 사항</em>
      <div className={cx('selectArea')}>
        <div className={cx('selectWrap')}>
          <Select
            {...statusField}
            className={cx('select', { error: statusMeta.invalid })}
            placeholder={'보훈 여부'}
            styles={ReactSelectStyles}
            isSearchable={false}
            options={veteranStatusOptions}
          />
          <ErrorMessage name={statusName} errors={statusErrors} />
        </div>
        <div className={cx('selectWrap', 'type2')}>
          <Input
            {...reasonField}
            value={reasonField.value ?? ''}
            className={cx({ error: reasonMeta.invalid })}
            type="text"
            maxLength={35}
            placeholder={'대상 사유를 입력해 주세요.'}
            disabled={isVeteranStatusNone}
          />
          <ErrorMessage name={reasonName} errors={reasonErrors} />
        </div>
      </div>
    </div>
  );
};

export default VeteranForm;
